import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useRouter } from '../../../hooks/use-router';
import { Button } from '../../button/button';
import { InfoBox } from '../../info-box/info-box';
import { Stack } from '../../stack/stack';

type Props = {
  companyName: string;
};

const InvitationAccepted = (props: Props) => {
  const { goToLoginPage } = useRouter();
  const { t } = useTranslation();

  return (
    <Stack direction="column" spacing={1.5}>
      <InfoBox color="green" leftIcon={{ icon: ['fad', 'check'] }}>
        <Trans
          components={{ bold: <strong /> }}
          i18nKey="newCompanyAdmin.common.invitationAccepted"
          ns="components"
          values={{ companyName: props.companyName }}
        />
      </InfoBox>

      <Stack direction="row" justifyContent="flex-end" spacing={0.5}>
        <Button color="primary" disabled={false} variant={'contained'} onClick={goToLoginPage}>
          {t('newCompanyAdmin.common.goToLoginPageButton', { ns: 'components' })}
        </Button>
      </Stack>
    </Stack>
  );
};

export { InvitationAccepted };
